import { gql } from '@apollo/client';
import { CORE_PAGE_INFO_FIELDS } from 'src/components/providers/apollo-provider-provider';

export const KNOWLEDGE_BASES_LIST_QUERY = gql`
  ${CORE_PAGE_INFO_FIELDS}
  query KnowledgeBasesList(
    $companyId: Int!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: AIAgentKnowledgeBaseOrderByInput
  ) {
    aiAgents {
      listKnowledgeBases(
        companyId: $companyId
        after: $after
        before: $before
        first: $first
        last: $last
        orderBy: $orderBy
      ) {
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
        nodes {
          id
          title
          sourcesCount
          createdAt
          aiAgents {
            id
            name
          }
          createdBy {
            id
            fullName
            avatar {
              color
              initials
              url(transform: { width: 180, height: 180 })
            }
            role {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const KNOWLEDGE_BASE_DETAIL_QUERY = gql`
  query KnowledgeBaseDetail($input: AIAgentKnowledgeBaseInput!) {
    aiAgents {
      getKnowledgeBase(input: $input) {
        id
        title
        aiAgents {
          id
          name
        }
      }
    }
  }
`;

export const CREATE_KNOWLEDGE_BASE_MUTATION = gql`
  mutation CreateKnowledgeBase($input: CreateAIAgentKnowledgeBaseInput!) {
    aiAgents {
      createKnowledgeBase(input: $input) {
        id
        title
      }
    }
  }
`;

export const UPDATE_KNOWLEDGE_BASE_MUTATION = gql`
  mutation UpdateKnowledgeBase($input: UpdateAIAgentKnowledgeBaseInput!) {
    aiAgents {
      updateKnowledgeBase(input: $input) {
        id
        title
      }
    }
  }
`;

export const DELETE_KNOWLEDGE_BASE_MUTATION = gql`
  mutation DeleteKnowledgeBase($input: AIAgentKnowledgeBaseInput!) {
    aiAgents {
      deleteKnowledgeBase(input: $input) {
        success
      }
    }
  }
`;

export const KNOWLEDGE_BASE_USAGE_QUERY = gql`
  query KnowledgeBaseUsage($input: AIAgentKnowledgeBaseInput!) {
    aiAgents {
      getKnowledgeBase(input: $input) {
        id
        usage {
          references {
            nodes {
              agent {
                id
              }
              sources {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

export const AI_AGENT_PRIVATE_KNOWLEDGE_BASE_USAGE_QUERY = gql`
  query AIAgentPrivateKnowledgeBaseUsage($input: AIAgentInput!) {
    aiAgents {
      getAIAgent(input: $input) {
        id
        privateKnowledgeBase {
          id
          usage {
            references {
              nodes {
                agent {
                  id
                }
                sources {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const LINK_KNOWLEDGE_BASE_MUTATION = gql`
  mutation LinkAgentKnowledgeBase($input: AIAgentKnowledgeBaseLinkInput!) {
    aiAgents {
      linkKnowledgeBase(input: $input) {
        id
      }
    }
  }
`;

export const UNLINK_KNOWLEDGE_BASE_MUTATION = gql`
  mutation UnlinkAgentKnowledgeBase($input: AIAgentKnowledgeBaseLinkInput!) {
    aiAgents {
      unlinkKnowledgeBase(input: $input) {
        id
      }
    }
  }
`;
